import { render } from "./CodigoParceiroTable.vue?vue&type=template&id=5d06e06a"
import script from "./CodigoParceiroTable.vue?vue&type=script&lang=js"
export * from "./CodigoParceiroTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__